import { render, staticRenderFns } from "./UserVoice.vue?vue&type=template&id=02793534&scoped=true&"
import script from "./UserVoice.vue?vue&type=script&lang=ts&"
export * from "./UserVoice.vue?vue&type=script&lang=ts&"
import style0 from "./UserVoice.vue?vue&type=style&index=0&id=02793534&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02793534",
  null
  
)

export default component.exports